import { render, staticRenderFns } from "./DocumentTemplateDetailTokenListExpansionHeader.vue?vue&type=template&id=1e42b35d&"
import script from "./DocumentTemplateDetailTokenListExpansionHeader.vue?vue&type=script&lang=ts&"
export * from "./DocumentTemplateDetailTokenListExpansionHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardSubtitle,VChip,VIcon})
